// natures video slider =============

var cm_videos_slidersd = new Swiper(".cm_videos_sliders", {
  slidesPerView: 1,
  spaceBetween: 28,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    576: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 3,
    },
    992: {
      slidesPerView: 3.5,
    },
    1200: {
      slidesPerView: 4,
    },
  },
});

// natures video play puse btn ========

document.addEventListener("DOMContentLoaded", function () {
  var videoItems = document.querySelectorAll(".video_slider_item");

  videoItems.forEach(function (item, index) {
    var video = item.querySelector("video");
    var playBtn = item.querySelector(".play");
    var pauseBtn = item.querySelector(".pause");

    function togglePlayPause(video, playBtn, pauseBtn) {
      if (video.paused) {
        video.play();
        playBtn.style.display = "none";
        pauseBtn.style.display = "block";
      } else {
        video.pause();
        playBtn.style.display = "block";
        pauseBtn.style.display = "none";
      }
    }

    if (playBtn && pauseBtn && video) {
      playBtn.addEventListener("click", function () {
        togglePlayPause(video, playBtn, pauseBtn);
      });

      pauseBtn.addEventListener("click", function () {
        togglePlayPause(video, playBtn, pauseBtn);
      });

      video.addEventListener("play", function () {
        playBtn.style.display = "none";
        pauseBtn.style.display = "block";
      });

      video.addEventListener("pause", function () {
        playBtn.style.display = "block";
        pauseBtn.style.display = "none";
      });
    }
  });
});

// review slider ===============

var review_slider_blocks = new Swiper(".review_slider_block", {
  slidesPerView: 1,
  spaceBetween: 10,
  loop: true,
  pagination: {
    el: ".review_slider_block .swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

// Featured Product Slider ==============================

var swiperslider = new Swiper(".featured_collection_main", {
  slidesPerView: 1,
  spaceBetween: 20,
  pagination: {
    el: ".swiper-pagination",
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    576: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    1440: {
      slidesPerView: 3,
      spaceBetween: 46,
    },
  },
});

// Quiz Js ==============================

document.addEventListener("DOMContentLoaded", function () {
  const questions = document.querySelectorAll(".quiz-question-box");
  const prevButton = document.querySelector(".quiz-prev-button");
  const nextButton = document.querySelector(".quiz-next-button");
  const findYouButton = document.querySelector(".find_you_button");
  const formulaButton = document.querySelector(".formula_button");
  const popupContainer = document.getElementById("quiz-popup");
  const closePopupButton = document.getElementById("close-popup");
  const introContainer = document.getElementById("intro-container");
  const quizContainer = document.getElementById("quiz-container");
  const resultContainer = document.getElementById("quiz-result-container");
  const quizResult = document.getElementById("quiz-result");
  const startQuizButton = document.getElementById("start-quiz-button");
  const seeQuizResultsButton = document.getElementById(
    "see-quiz-results-button"
  );
  const restartQuizButton = document.getElementById("restart-quiz-button");
  const lastStepLeft = document.querySelector(".last_step_left");

  const dynamicResult = document.getElementById("dynamic-result"); // For showing result dynamically
  const resultDiv = document.getElementById("result-container"); // The result div to display

  let currentQuestion = 0;

  // Show the popup when "Find You" or "Formula" button is clicked
  findYouButton.addEventListener("click", function () {
    popupContainer.style.display = "flex"; // Show the popup
  });

  formulaButton.addEventListener("click", function () {
    popupContainer.style.display = "flex"; // Show the popup
  });

  // Close the popup when the "close" button is clicked
  closePopupButton.addEventListener("click", function () {
    popupContainer.style.display = "none"; // Hide the popup
  });

  // Close the popup when the user clicks outside the popup
  window.addEventListener("click", function (event) {
    if (event.target === popupContainer) {
      popupContainer.style.display = "none"; // Hide the popup
    }
  });

  // Event listener for starting the quiz
  startQuizButton.addEventListener("click", function () {
    introContainer.style.display = "none"; // Hide the intro content
    quizContainer.style.display = "block"; // Show the quiz content
    questions[currentQuestion].classList.add("active"); // Show the first question
  });

  // Event listener for the Next button
  nextButton.addEventListener("click", function () {
    const currentAnswers = questions[currentQuestion].querySelectorAll(
      'input[type="radio"]'
    );
    let isSelected = false;

    currentAnswers.forEach((answer) => {
      if (answer.checked) {
        isSelected = true;
      }
    });

    if (!isSelected) {
      alert("Please select an option before proceeding.");
      return;
    }

    if (currentQuestion < questions.length - 1) {
      questions[currentQuestion].classList.remove("active");
      currentQuestion++;
      questions[currentQuestion].classList.add("active");

      // Change button text to "See Quiz Results" for the last question
      if (currentQuestion === questions.length - 1) {
        nextButton.textContent = "See Quiz Results";
      }
    } else {
      // If last question, hide quiz and show result buttons
      quizContainer.style.display = "none"; // Hide quiz
      resultContainer.style.display = "block"; // Show results button and restart button
    }

    prevButton.disabled = currentQuestion === 0;
  });

  // Event listener for the Prev button
  prevButton.addEventListener("click", function () {
    if (currentQuestion > 0) {
      questions[currentQuestion].classList.remove("active");
      currentQuestion--;
      questions[currentQuestion].classList.add("active");
      nextButton.textContent = "Next"; // Reset button text
    }

    prevButton.disabled = currentQuestion === 0;
  });

  // Event listener for the See Quiz Results button to open product page
  seeQuizResultsButton.addEventListener("click", function () {
    let selectedOption = null;

    // Check which option is selected
    if (document.getElementById("quiz-answers-1").checked) {
      selectedOption = 1;
    } else if (document.getElementById("quiz-answers-2").checked) {
      selectedOption = 2;
    } else if (document.getElementById("quiz-answers-3").checked) {
      selectedOption = 3;
    } else if (document.getElementById("quiz-answers-4").checked) {
      selectedOption = 4;
    } 

    // Redirect to the appropriate product URL based on the selected option
    switch (selectedOption) {
      case 1:
        window.location.href = "https://www.citrusreefs.com/products/sea-moss";
        break;
      case 2:
        window.location.href =
          "https://www.citrusreefs.com/products/miracle-berry";
        break;
      case 3:
        window.location.href =
          "https://www.citrusreefs.com/products/matcha-sea-moss";
        break;
      case 4:
        window.location.href =
          "https://www.citrusreefs.com/products/golden-sea-moss-eucheuma-cottonii";
        break;
      case 5:
        window.location.href =
          "https://www.citrusreefs.com/products/golden-sea-moss-eucheuma-cottonii";
        break;
      case 6:
        window.location.href =
          "https://www.citrusreefs.com/products/matcha-sea-moss";
        break;
      default:
        alert("Please select an option before proceeding.");
    }
  });

  // Event listener for restarting the quiz
  restartQuizButton.addEventListener("click", function () {
    resultContainer.style.display = "none"; // Hide result
    introContainer.style.display = "block"; // Show the intro again
    currentQuestion = 0; // Reset current question
    questions.forEach((question) => question.classList.remove("active")); // Hide all questions
    nextButton.textContent = "Next"; // Reset button text
    prevButton.disabled = true; // Disable Prev button initially
  });

  // Initially disable Prev button
  prevButton.disabled = true;
});
// Handling the UI state of quiz answers
const answersList = document.querySelectorAll(".quiz-question-answers-list li");
answersList.forEach((li) => {
  const radioInput = li.querySelector('input[type="radio"]');
  radioInput.addEventListener("change", () => {
    answersList.forEach((item) => item.classList.remove("active"));
    if (radioInput.checked) {
      li.classList.add("active");
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
    const continueBtn = document.getElementById("continueBtn"); // Change this to your actual button ID or class
    const mainOptions = document.querySelectorAll(".main-option"); // Add class to your main selection options
    const subOptionsContainer = document.getElementById("subOptions"); // Div where sub-options will be displayed

    const subOptions = {
        "Beauty": ["Acne", "Hyperpigmentation"],
        "Skin Health": ["Eczema", "Psoriasis", "Similar"],
        "Hormone Balance": ["Bloating", "Gut Health", "Digestion Issues"]
    };

    continueBtn.addEventListener("click", function () {
        let selectedOption = "";
        
        mainOptions.forEach(option => {
            if (option.checked) { // If radio button/checkbox is checked
                selectedOption = option.value;
            }
        });

        if (selectedOption && subOptions[selectedOption]) {
            // Clear previous sub-options
            subOptionsContainer.innerHTML = "";

            // Create and show new sub-options
            subOptions[selectedOption].forEach(sub => {
                const label = document.createElement("label");
                const input = document.createElement("input");
                input.type = "radio"; // Change to "checkbox" if multiple selection allowed
                input.name = "sub-option";
                input.value = sub;

                label.appendChild(input);
                label.appendChild(document.createTextNode(" " + sub));
                subOptionsContainer.appendChild(label);
                subOptionsContainer.appendChild(document.createElement("br"));
            });
        }
    });
});


// product faq ================

$(document).ready(function () {
  $(".product_faq_content .product_faq_main_item")
    .first()
    .find(".product_faq_answer_block")
    .slideDown();
  $(".product_faq_content .product_faq_main_item").first().addClass("active");

  $(".product_faq_heading").click(function () {
    var $currentItem = $(this).closest(".product_faq_main_item");

    if ($currentItem.hasClass("active")) {
      $currentItem.find(".product_faq_answer_block").slideUp();
      $currentItem.removeClass("active");
    } else {
      $(".product_faq_main_item.active")
        .find(".product_faq_answer_block")
        .slideUp();
      $(".product_faq_main_item.active").removeClass("active");

      $currentItem.find(".product_faq_answer_block").slideDown();
      $currentItem.addClass("active");
    }
  });
});

// remove class in header drawer ===================

$(document).ready(function () {
  $(".drawer__close-button.js-drawer-close").on("click", function () {
    $(".mobile-nav__sublist, .collapsible-trigger")
      .removeClass("is-open")
      .css("height", "");
  });
});

// ======================
